module.exports = __webpack_public_path__ + "img/marketing-digital.b199e145.svg";